/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLoader3 = createReactComponent("outline", "loader-3", "IconLoader3", [["path", { "d": "M3 12a9 9 0 0 0 9 9a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9", "key": "svg-0" }], ["path", { "d": "M17 12a5 5 0 1 0 -5 5", "key": "svg-1" }]]);

export { IconLoader3 as default };
//# sourceMappingURL=IconLoader3.mjs.map
